import { render, staticRenderFns } from "./JobCategoriesList.vue?vue&type=template&id=599fec8b"
import script from "./JobCategoriesList.vue?vue&type=script&lang=js"
export * from "./JobCategoriesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports